{
  "errors": {
    "unknown_error": "An unknown error occurred. Please try again.",
    "user_exists": "A user with this email address already exists",
    "validation_failed": "Oh no! Validation failed. Please check that your email is entered correctly.",
    "wrong_password": "Your current password is wrong",
    "code_invalid": "That code isn't right. Check it and try again, or request a new one.",
    "code_expired": "That code has expired. Request a new one to continue.",
    "server_code": {
      "unknown": "Unable to log in: An unexpected error has occurred and support has been notified"
    }
  },
  "validation": {
    "required": "Required",
    "email_too_short": "Email must be at least 5 characters long",
    "email_invalid": "Enter a valid email",
    "password_too_short": "Password must be at least 8 characters long",
    "passwords_dont_match": "Passwords must match",
    "code_incomplete": "Enter all 6 digits"
  },
  "email": "Email address",
  "edit_email": "Edit",
  "password": "Password",
  "password_show": "Show",
  "password_hide": "Hide",
  "name": "Name",
  "or": "or",
  "continue": "Continue",
  "code": "Login code",
  "check_your_email": "Check your email",
  "code_sent_to": "We sent a 6-digit code to {{email}}.",
  "code_expires": "It expires in 10 minutes.",
  "code_resend": "Didn't get it? Resend",
  "code_resend_in": "Resend in {{time}}",
  "code_submit": "Log in",
  "email_me_a_code": "Email me a code instead",
  "name_prompt_title": "You're in!",
  "name_prompt_byline": "One last thing — what should we call you?",
  "name_your": "Your name",
  "name_prompt_submit": "Finish setting up",
  "name_prompt_skip": "Skip this",
  "create_account": "Create account",
  "forgot_password": "Forgot your password?",
  "welcome_back": "Welcome back!",
  "sign_up": "Sign up",
  "sign_in": "Log in",
  "sign_out": "Log out",
  "sign_in_or_create": "Log in or create an account",
  "sign_into_account": "Log into your existing account",
  "sign_in_with_google": "This account uses Google to log in",
  "sign_in_with_google_go_back": "If you'd like to use a different email address, <2>go back</2>",
  "sign_in_with_apple_go_back": "If you'd like to use a different email address, <2>go back</2>",
  "sign_in_success_toast": "You're now logged in!",
  "sign_up_success_toast": "Welcome to Agenda Hero! Thanks for signing up",
  "google_register": "Sign up with Google",
  "google_login": "Log in with Google",
  "apple_register": "Sign up with Apple",
  "apple_login": "Sign in with Apple",
  "sign_in_with_apple": "This account uses Apple to log in",
  "create_free_account": "Create your free account",
  "create_for_free": "Create for free",
  "register_modal_actions": {
    "follow_schedule": "Log in to save this schedule to your dashboard for quick access",
    "save_page": "Login or create an account to save this schedule",
    "follow_item": "Log in to add this item to your personal calendar and receive email updates if its details change",
    "rsvp_item": "Log in to RSVP to this item.",
    "copy_public_schedule": "Copy this schedule into your own account where you can edit or create new items!",
    "subscribe_experience": "Log in to subscribe and receive updates for this page"
  },
  "register_modal_message": {
    "register": "Sign up to {{action}}",
    "login": "Log in to {{action}}"
  },
  "terms": "By logging in, you agree to our <2>Terms</2> and have read and acknowledge our <6>Privacy Statement</6>."
}
